import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

export type RiskWarningFields = {
  descriptionExtra: Field<string>;

  title: Field<string>;

  description: Field<string>;

  link: Field<{ href: string; text: string }>;
};
